import React from 'react';
import PropTypes from 'prop-types';
import style from '../../style/components/signin/SecurityStrengthIndicator.module.scss';

const getLineClass = (index, level) => {
  if (level === 1 && index === 0) return style.fair;
  if (level === 2 && index < 2) return style.moderate;
  if (level === 3 && index < 3) return style.strong;
  if (level === 4) return style.veryStrong;
  return '';
};

const SecurityStrengthIndicator = ({ level, label }) => (
  <div className={style.indicator}>
    <div className={style.lines}>
      {[0, 1, 2, 3].map((i) => (
        <span key={i} className={`${style.line} ${getLineClass(i, level)}`} />
      ))}
    </div>
    <span className={style.label}>{label}</span>
  </div>
);

SecurityStrengthIndicator.propTypes = {
  level: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
};

export default SecurityStrengthIndicator;
